import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-546f05e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Wenn du diesen Benutzer aus dieser Gruppe entfernst, werden ihm die Berechtigungen, die von dieser Gruppe stammen, entzogen. Du kannst den Benutzer selbstverständlich jederzeit wieder zu dieser Gruppe hinzufügen. ")
const _hoisted_2 = { class: "remove-from-group-modal-preview" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Benutzer", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Gruppe", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Abbrechen")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Benutzer aus Gruppe entfernen")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_modal = _resolveComponent("md-modal")!

  return (_openBlock(), _createBlock(_component_md_modal, {
    ref: "modal",
    title: "Benutzer aus Gruppe entfernen?",
    icon: "person_remove",
    variant: "delete",
    loading: _ctx.loading || _ctx.modalIsLoading
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("h2", null, _toDisplayString(_ctx.user?.name), 1),
        _hoisted_4,
        _createElementVNode("h2", null, _toDisplayString(_ctx.group.name), 1)
      ])
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_md_button, {
        variant: "text",
        grey: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_md_button, {
        variant: "filled",
        mode: "delete",
        onClick: _ctx.removeFromGroup
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["loading"]))
}